import * as React from "react";
import CreateService from "../../service/create";
import PopDetail from "../popdetail";
import ReadService from "../../service/read";
import Wait from "../wait";
import ReportFilterPane from "../v1/report/report_filter";
import CCROUploadResult from "./ccro_upload_result";

export default class CCROUploadShpPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            srid: 0,
            villages: []
        }


        this.loadData = this.loadData.bind(this)
        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.handleChangeFile = this.handleChangeFile.bind(this)
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }
    handleChangeFile = e => {
        this.setState({zipped: e.target.files[0]})
    }


    render() {
        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0}}>

                <table style={{width: '94%', margin: '2%'}}>
                    <tbody>


                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Shapefile</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'file'} style={{width: '100%'}} accept=".zip,.ZIP" name={'zipped'}
                                   onChange={this.handleChangeFile}/>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Submit
                    </button>
                    <button className={'btn error'} onClick={() => PopDetail.dismiss()}>
                        <span className={'fa fa-times'} style={{padding: 0}}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }

    loadData() {

        try {
            Wait.show('Fetching Villages....')
            ReadService.fetchProjectVillages(this.props.project.id).then(r => {
                Wait.dismiss()
                this.setState({
                    villages: r.data.results
                })
            })
        } catch (e) {
            console.log(e)
        }

        //console.log('here,...')
        //console.log(this.props.project)
    }


    submit() {
        try {
            const formData = new FormData()
            formData.append('zipped', this.state.zipped)
            formData.append('extra', JSON.stringify({
                project_id: this.props.project.id,
                task_id: this.props.task_id,
                screen_code: this.props.screen_code
            }))

            Wait.show('Creating Layer...')
            CreateService.createLayer(formData).then(d => {
                Wait.dismiss()
                //alert(d.data.response.success + d.data.response.failure)
                this.props.loadData()
                PopDetail.dismiss()
                PopDetail.showDynamic('Upload Result',<CCROUploadResult response={d.data.response} key={new Date()}/>,40, 40)
            })

        } catch (e) {
            alert(e)
        }
    }


}